























import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import TableColumn from "./TableColumn.vue";
import TableTotal from "./TableTotal.vue";

type StatisticItem = {
    activity_id: number,
    content_pack_id: number,
    duration: number,
    players_count: string
}

type Pack = {
    id: number,
    name: string
}

type Activity = Pack & {
    contentPacks: {[key: string]: Pack},
}

@Component({
    components: {TableTotal, TableColumn},
})

export default class Table extends Vue {
    @Prop({required: true}) private readonly code!: {[key: string]: Record<string, Array<StatisticItem>> };
    @Prop({required: true}) private readonly name!: string;
    @Prop({required: true}) private readonly index!: number;
    @Prop({required: true}) private readonly activities!: {[key: number]: Activity};

    private isOpened: boolean = false;

    mounted(): void {
        if (!this.index) {
            this.isOpened = true;
        }
    }

    private toggleVisibility(): void
    {
        this.isOpened = !this.isOpened;
    }

    /**
     * Получить имя игры
     * @param id
     * @private
     */
    private getGameName(id: string|number): string
    {
        if (id === '') {
            return 'Start page';
        }

        if (id === '0') {
            return 'Sandbox';
        }

        if (this.activities && typeof this.activities[id as number] !== 'undefined') {
            return this.activities[id as number].name;
        }

        return '';
    }

    private getContentPacks(id: string, info: Array<StatisticItem>): {[key: string]: Array<StatisticItem>}|null
    {
        if (!this.activities) {
            return null;
        }
        const activity: Activity = this.activities[id as any];

        if (typeof activity === 'undefined') {
            return null;
        }

        const activityPacks = activity.contentPacks;

        if (id === '' || id === '0') {
            return {'': info};
        } else {
            const obj = {};
            for (let pack in activityPacks) {
                info.forEach(item => {
                    if (activityPacks[pack].id === item.content_pack_id) {
                        // @ts-ignore
                        if (obj[activityPacks[pack as any].name] instanceof Array) {
                            // @ts-ignore
                            (obj[activityPacks[pack as any].name] as Array<StatisticItem>).push(item);
                        } else {
                            // @ts-ignore
                            obj[activityPacks[pack as any].name] = [item];
                        }
                    }
                });
            }

            return obj;
        }

        return null;
    }
}
